import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SubflotasComponent } from './subflotas/subflotas.component';
import { MovilesCercaComponent } from './moviles-cerca/moviles-cerca.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormSubflotaComponent } from './subflotas/form-subflota/form-subflota.component';
import { WindowComponent } from 'movisat-common-gui';


@NgModule({
  declarations: [
    SubflotasComponent,
    MovilesCercaComponent,
    FormSubflotaComponent,
  ],
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    WindowComponent
  ]
})
export class FlotaModule { }
